import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import MakeLeapsLogoFullWidth from 'assets/svg/MakeLeapsLogoFullWidth';
import clsx from 'clsx';
import LinkButton from 'components/LinkButton';
import DropdownSelectLocale from 'components/Locale/DropdownSelectLocale';
import {Size} from 'types';

type HeaderBasicProps = {
    className?: string;
    dropdownSelectLocalSize?: Size;
    showLanguage?: boolean;
    showSignIn?: boolean;
};

const HeaderBasic: FC<HeaderBasicProps> = ({
    className,
    dropdownSelectLocalSize,
    showLanguage = true,
    showSignIn = true,
}) => {
    const {i18n, t} = useTranslation();

    return (
        <header className={clsx('flex items-center pt-8', className)}>
            <a
                aria-label="home"
                href={`https://www.makeleaps.com/${i18n.language}/`}
            >
                <MakeLeapsLogoFullWidth className="max-w-40" />
            </a>
            <div className="flex flex-1 justify-end">
                {showSignIn && (
                    <LinkButton
                        className="ml-2"
                        href={window.Urls.login_view()}
                        kind="tertiary"
                    >
                        <span className="text-green-600">
                            {t('header.signIn')}
                        </span>
                    </LinkButton>
                )}
                {showLanguage && (
                    <DropdownSelectLocale size={dropdownSelectLocalSize} />
                )}
            </div>
        </header>
    );
};

export default HeaderBasic;
